import axios from "axios";
import Cookies from "js-cookie";

const token = Cookies.get("echohouse_website");

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  },
  // timeout: 5000,
});

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      const token = Cookies.get("echohouse_website");

      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      } else {
        config.headers["Authorization"] = "";
      }

    
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default axiosClient;
